/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import { bool, shape, string, arrayOf } from 'prop-types';
import { FlexibleLayoutRenderer } from './FlexibleLayoutRenderer';
import BackgroundImage from './components/BackgroundImage/BackgroundImage';

/**
 * Main job for this component is to fetch data. The useDataModel call will cause this component to rerender which is
 * why the rendering of the components is split into FlexibleLayoutRenderer so that they don't unnecessarily renderer.
 * Rerendering components can result in extra API calls and processing, we do not want that.
 */

export const FlexibleLayout = ({
  canonicalURL, data, customerType, filterBreadcrumbs, pageId, storeId, pageTypeComponents, thdSEOBotDetection, isPreviewLink
}) => {

  let search = '';

  const backgroundImageConfig = data?.layouts?.content?.backgroundImage;

  const hasValidBackgroundImage = backgroundImageConfig?.desktopImage?.damContentSelector?.assetData?.[0]?.selectedImageUrl
    || backgroundImageConfig?.desktopImage?.damDownloadedContent?.url
    || backgroundImageConfig?.mobileImage?.damContentSelector?.assetData?.[0]?.selectedImageUrl
    || backgroundImageConfig?.mobileImage?.damDownloadedContent?.url;

  if (typeof window !== 'undefined') {
    search = window.location?.search;
  }

  const flexibleContent = (
    <FlexibleLayoutRenderer
      canonicalURL={canonicalURL}
      data={data}
      filterBreadcrumbs={filterBreadcrumbs}
      pageId={pageId}
      customerType={customerType}
      storeId={storeId}
      pageTypeComponents={pageTypeComponents}
      search={search}
      thdSEOBotDetection={thdSEOBotDetection}
      isPreviewLink={isPreviewLink}
    />
  );

  return hasValidBackgroundImage ? (
    <BackgroundImage
      desktopImage={backgroundImageConfig?.desktopImage}
      mobileImage={backgroundImageConfig?.mobileImage}
      scrollBehavior={backgroundImageConfig?.scrollBehavior}
    >
      {flexibleContent}
    </BackgroundImage>
  ) : flexibleContent;
};

FlexibleLayout.displayName = 'FlexibleLayout';

FlexibleLayout.propTypes = {
  canonicalURL: string,
  customerType: string.isRequired,
  data: shape({}).isRequired,
  filterBreadcrumbs: arrayOf(shape(
    {
      browseUrl: string,
      label: string,
    },
  )),
  pageTypeComponents: shape({}).isRequired,
  pageId: string.isRequired,
  storeId: string.isRequired,
  thdSEOBotDetection: bool,
  isPreviewLink: bool
};

FlexibleLayout.defaultProps = {
  canonicalURL: null,
  thdSEOBotDetection: false,
  filterBreadcrumbs: null,
  isPreviewLink: false
};